import { render, staticRenderFns } from "./UiNav.vue?vue&type=template&id=c59fbab2&lang=pug&"
import script from "./UiNav.vue?vue&type=script&lang=js&"
export * from "./UiNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports